<template>
  <div id="app">
    <flightsite-nav></flightsite-nav>
    <section class="route-wrapper">
      <router-view />
    </section>
    <home-content v-if="$route.name === 'search'"></home-content>
    <flightsite-footer  v-if="$route.name !== 'results'"></flightsite-footer>
  </div>
</template>

<script>
import HomeContent from "@/components/HomeContent.vue";
import FlightsiteFooter from "@/components/FlightsiteFooter.vue";
import FlightsiteNav from "@/components/FlightsiteNav.vue";

export default {
  data: function() {
    return {};
  },
  computed: {},
  created: function() {},
  components: {
    HomeContent,
    FlightsiteFooter,
    FlightsiteNav
  }
};
</script>

<style lang="scss">
@import "./assets/styles/settings.scss";

* {
  box-sizing: border-box;
}
html,
body {
  max-width: 100%;
  overflow-x: hidden;
  background: $grey;
  margin: 0;
}
</style>

<style lang="scss" scoped>
@import "./assets/styles/settings.scss";

.route-wrapper {
  position: sticky;
  max-width: -webkit-fill-available;
}

#app {
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100vw;
}

nav {
  background: $light;
  padding: $standard-padding;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 80px;
  border-bottom: 4px solid $primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 24px;
    font-weight: 200;
    color: $dark;
    b {
      color: $primary-color;
      font-weight: 600;
    }
  }
  img {
    max-height: 60px;
  }
}

@media (min-width: 781px) {
  .route-wrapper {
  }
}
</style>

<style lang="scss">
@import "./assets/styles/settings.scss";
</style>